var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2 4l.4-1.8c0-.2.2-.3.4-.3h6c.2 0 .4.1.4.3l.4 1.8H8.2zm7.9 12.7c.2.2.2.6 0 .9-.2.2-.6.2-.9 0L12 14.3l-3.2 3.3c-.2.2-.6.2-.9 0s-.2-.6 0-.9l3.2-3.3-3.2-3.3c-.1-.2-.2-.4-.1-.6 0-.3.2-.4.4-.5.2 0 .4 0 .6.2l3.2 3.3 3.2-3.3c.2-.2.6-.2.9 0 .2.2.2.6 0 .9l-3.2 3.3 3.2 3.3zM20.9 4h-4.2l-.4-2c-.1-.6-.7-1-1.3-1H9c-.6 0-1.1.4-1.3 1l-.4 2H3.1c-.3 0-.5.2-.5.5s.2.5.5.5h1.4l.8 16.7c0 .7.6 1.3 1.3 1.3h10.8c.7 0 1.3-.6 1.3-1.3L19.6 5h1.3c.2 0 .4-.2.4-.5s-.2-.5-.4-.5z"
  })));
}

export default SvgBin;